import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { BuilderWrapper } from './style';

type Props = RouteComponentProps;

const SITE_BUILDER_DOMEN = process.env.SITEBUILDER_URL as string;
// const DEV_SITE_BUILDER_DOMEN = 'http://localhost:3000'; На случай, если необходимо посмотреть с локально-запущенным сайтбилдером
const SB_CLOSE = 'sb-close'; // Событие закрытие конструктора. При появлении данного события необходимо перекинуть на страницу с виджетом

const WidgetBuilder = ({ match, history }: Props) => {
  const { projectId } = match.params as RouteParams;
  const { customizeWidgetPath } = usePaths();

  const onClosed = useCallback(() => {
    history.push({
      pathname: customizeWidgetPath(projectId)
    });
  }, []);
  const listenerPostMessage = useCallback((event) => {
    if (event.data) {
      try {
        const messageData: { command: string } = JSON.parse(event.data);
        if (messageData.command && messageData.command === SB_CLOSE) {
          onClosed();
        }
      } catch (e) {
        // если в data не json, ничего не делаем
      }
    }
  }, []);

  useEffect(() => {
    if (window && window.addEventListener) {
      window.addEventListener('message', listenerPostMessage);
    }
  }, []);

  return (
    <BuilderWrapper>
      <iframe
        title="site-builder"
        name="site-builder"
        width="100%"
        height="100%"
        src={`${SITE_BUILDER_DOMEN}/widget-login/${projectId}`}
        data-test-id="wc_site-builder-editor"
        frameBorder="0"
      />
    </BuilderWrapper>
  );
};

export default withRouter(WidgetBuilder);
